// src/call-all-fn.ts
function callAllFn(...fns) {
  return (...args) => fns.forEach((fn) => fn == null ? void 0 : fn(...args));
}
var call_all_fn_default = callAllFn;

export {
  call_all_fn_default
};
